
function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();
    
    $("body").append($temp);
    $temp.val($(element).html()).select();
    document.execCommand("copy");
    $(element).html("COPIADO");
    setTimeout(function(){ $(element).html(oldValue); }, 300);
    $temp.remove();
  
  } 
  
  $('cupom').click(function(){
    copyToClipboard(this);
  });
